<template>
  <div class="page page__list">
    <search-bar @search="onSearch" name="vi_obj_name" placeholder="输入拜访对象进行查找" ref="searchBar" />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link class="weui-cell weui-cell_access" v-for="item in items" :key="item.id"
        :to="'/oa/visit_inner_visitor/' + item.vi_recordid">
        <div class="weui-cell__bd">
          <p>{{ item.vi_obj_name }}</p>
          <p class="list-item-muted">{{ item.vi_visittime }}</p>
        </div>
        <div class="weui-cell__ft">
          <p>{{ item.vi_obj_corpname }}</p>
          <span class="list-item-status" :class="{ warning: item.vi_status != 1 }">{{ item.status }}</span>
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{ items.length }}次</label>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";
import Finger from "@/util/finger.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList,
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/oa/visit_inner/visitor_list",
      filters: [
        {
          type: "date",
          name: "vi_visittime",
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          options: [
            {
              value: -1,
              label: "全部",
            },
            {
              value: 1,
              label: "待确认",
              condition: "vi_status=0",
            },
            {
              value: 2,
              label: "已同意",
              condition: "vi_status=1",
            },
            {
              value: 2,
              label: "已拒绝",
              condition: "vi_status=2",
            },
          ],
        },
      ],
    };
  },
  computed: {
    extraParams() {
      return { clientId: this.getClientId() };
    },
  },
  methods: {
    getClientId() {
      var me = this, clientId = me.clientId;
      if (!clientId) {
        clientId = me.clientId = me.$route.params.clientId;
      }
      if (!clientId) {
        clientId = me.clientId = Finger.get();
      }
      return clientId;
    },
  },
};
</script>